/**
* @ngdoc directive
* @name tcApp.directive:tcPerformance
* Capture page load performance statsitics
*/

angular.module('tc.performance', [])
.service('PerformanceService', function($log, $location, $window, $document, $rootScope, $timeout) {
	
	var serviceInstance = this;
	
	// Called from GlobalService on update of sessionData
	this.initialise = function(capturePerformanceData, serverMethod) {
		serviceInstance.clear();
		serviceInstance.capture = capturePerformanceData;
		serviceInstance.serverMethod = serverMethod;
		serviceInstance.processingEvent = false;
	};
	
	/**
	* @ngdoc method
	* @name onLoaded
	* @methodOf tcApp.PerformanceService
	* @description
	* Pass performance data to server after load of a page
	* 
	* @param {Object} params Additional paramters to be passed to server (e.g. Component Name, Workflow Id)
	* @param {boolean} waitForStable When true, will not calculate performance time until the page body is stable
	*/
	this.onLoaded = function(params, waitForStable) {		
		if (!serviceInstance.capturePerformanceData()) return;
		if (!serviceInstance.isProcessingEvent()) return;
		try {
			var storePerformanceData = function() {
				var now = (new Date).getTime();
				var navigationStart = serviceInstance.loadParameters.navigationStart;
				var url = $location.url();
				var loadTime = 0;
				loadTime = now - navigationStart;
				if ((angular.isNumber(loadTime)) && (loadTime > 0)) {
					if (angular.isUndefined(params)) params = {};
					if (serviceInstance.loadParameters) {
						params['menuId'] = serviceInstance.loadParameters.menuId;
						if (serviceInstance.loadParameters.processEventParams) {
							params['eventComponentItem'] = serviceInstance.loadParameters.processEventParams.eventItemName;
							params['eventComponentName'] = serviceInstance.loadParameters.processEventParams.componentName;
						}
					}
					var paramsString = angular.toJson(params);
					if (angular.isFunction($window.navigator.sendBeacon)) {
						// New function: Chrome, Edge, FF
						var parameters = [
							'WARGC=4',
							'WEVENT=' + serviceInstance.serverMethod,
							'WARG_1=' + encodeURIComponent(url),
							'WARG_2=' + loadTime,
							'WARG_3=' + paramsString,
							'WARG_4=' + 1
						];
						$window.navigator.sendBeacon('%25CSP.Broker.cls?' + parameters.join('&'));
					} else {
						// Old function: IE, Safari
						$window.cspHttpServerMethod(serviceInstance.serverMethod, url, loadTime, paramsString, 1);
					}
				}
				serviceInstance.stopProcessingEvent();				
			};
			
			if (waitForStable === true) {
				angular.getTestability(angular.element($document[0].body)).whenStable(storePerformanceData);
			} else {
				storePerformanceData();		
			}	
		} catch (exception) {
			if (angular.isDefined(exception)) $log.error(exception);
			serviceInstance.stopProcessingEvent();
		}		
	};

	this.stopProcessingEvent = function() {
		if (!serviceInstance.capturePerformanceData()) return;
		try {
			serviceInstance.clear();
			serviceInstance.setProcessingEvent(false);
		} catch (exception) {
			if (angular.isDefined(exception)) $log.error(exception);
		}
		
	};

	this.loadInterrupted = function() {
		serviceInstance.onLoaded({loadInterrupted: 1}, false);
	};
		
	this.onProcessEvent = function(componentName, eventItemName) {
		if (serviceInstance.capturePerformanceData()) {
			serviceInstance.clear();
			var eventParams = {
				componentName: componentName,
				eventItemName: eventItemName
			};
			serviceInstance.loadParameters.processEventParams = eventParams;
			serviceInstance.setNavigationStart();
		}
	};
	
	this.setNavigationStart = function() {
		if (serviceInstance.capturePerformanceData()) {
			serviceInstance.setProcessingEvent(true);
			serviceInstance.loadParameters.navigationStart = (new Date).getTime();
		}
	};

	this.setProcessingEvent = function(isProcessingEvent) {		
		serviceInstance.processingEvent = isProcessingEvent;
	};

	this.isProcessingEvent = function() {
		return (angular.isDefined(serviceInstance.processingEvent) && (serviceInstance.processingEvent));
	};

	this.onLocationChange = function() {
		if ((serviceInstance.capturePerformanceData())
			&& (angular.isUndefined(serviceInstance.loadParameters.processEventParams))) {
			serviceInstance.setNavigationStart();
		}	
	};
	
	this.onMenu = function(menuId) {
		if (serviceInstance.capturePerformanceData()) {
			serviceInstance.clear();
			serviceInstance.loadParameters.menuId = menuId;
		}
	};
	
	this.clear = function() {
		serviceInstance.loadParameters = {};
	};
	
	this.capturePerformanceData = function() {
		return serviceInstance.capture;
	};

	// When changing routes, initialise time
	$rootScope.$on('$routeChangeStart', function() { //eslint-disable-line angular/on-watch
		serviceInstance.setNavigationStart();
	});

	// When we successfully change routes, toggle tools off and either scroll to previous position or focus first
	$rootScope.$on('$routeChangeSuccess', function($event, newRoute) { //eslint-disable-line angular/on-watch
		var params = {};
		if (newRoute.params.componentName) params.componentName = newRoute.params.componentName;
		$timeout(serviceInstance.onLoaded(params, true));
	});

});
